module.exports = __webpack_public_path__ + "img/pin_taxi_to@3x.df088998.png";